

































































































































































import { uniq } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import { SelectOption } from "../../logic/types";
import { ChipsWithSelectData, ChipsInputTabs } from "../Pi/fields/ChipsInput/types";
import ChipsInputField from './ChipsInputField.vue'
import ChipsTag from './components/ChipsTag.vue'
import ChipsTags from './components/ChipsTags.vue'
import { reflectChipsValues, reflectedStringToList } from "./logic/reflectChipsValues";

@Component({
  data() {
    return {
      ChipsInputTabs
    }
  },
  components: {
    ChipsTag,
    ChipsTags,
    ChipsInputField,
    draggable,
  },
})
export default class Chips extends Vue {
  @VModel({ type: Array }) chips!: Array<string | number> | null

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop() options!: Array<SelectOption | string> | null

  @Prop({ default: false }) draggable!: boolean

  @Prop() availableTabs!: Array<ChipsInputTabs>

  @Prop() formatter!: ChipsWithSelectData['formatter']

  activeCollapsePanel: Array<string> = []

  activeTab = 0

  textAreaValue = ''

  filterInputText = ''

  get tabBarStyles(): Partial<CSSStyleDeclaration> {
    if (!this.$screen.md) {
      return {
        display: 'flex',
        flexDirection: 'column-reverse',
        order: '1'
      }
    }

    return {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between'
    }
  }

  get searchable(): boolean {
    if (this.chips === null) {
      return false
    }

    return this.chips.length >= 40
  }

  get searchQueryMatch(): Array<string | number> {
    if (this.chips) {
      if (this.filterInputText !== '') {
        return this.chips.filter((chip) => chip.toString().toLowerCase().includes(this.filterInputText.toLowerCase()))
      }

      return this.chips
    }

    return []
  }

  get firstFiveInSearchQueryMatch() {
    return this.searchQueryMatch.slice(0,5).map(w => {
      if (typeof w === 'string') {
        return w.slice(0, 50)
      }

      return w
    }).join(', ')
  }

  @Emit()
  update(chips: Array<string | number>) {
    return chips
  }

  get chipsModel(): Array<string | number> {
    if (this.chips) {
      return [ ...this.chips ]
    }

    return []
  }

  set chipsModel(value: Array<string | number>) {
    this.setValue(value.filter((str, index, self) => self.indexOf(str) === index && str.toString().trim().length > 0))
  }

  addWord(inputValue: string): void {
    this.chipsModel = [ ...this.chipsModel, inputValue ]
  }

  reflectStringOnGet(): string {
    return this.chipsModel
      .map((item) => reflectChipsValues('', item.toString()))
      .join(', ')
  }

  onTextareaTabClick(): void {
    this.copyValuesToTextarea()
  }

  copyValuesToTextarea(): void {
    this.textAreaValue = this.reflectStringOnGet()
  }

  onTextareaBlur(): void {
    this.setValue(uniq(reflectedStringToList(this.textAreaValue)))

    this.$nextTick(() => {
      this.copyValuesToTextarea()
    })
  }

  setValue(value: Array<string | number>): void {
    this.$emit('input', value)
  }

  removeWord(value: string | number): void {
    const arr = [ ...this.chipsModel ]
    const index = arr.indexOf(value)

    if (index > -1) {
      arr.splice(index, 1)
    }

    this.setValue(arr)
  }

  hasTab(tab: ChipsInputTabs) {
    if (this.availableTabs) {
      return this.availableTabs.includes(tab)
    }

    return true
  }

  mounted(): void {
    if (this.availableTabs) {
      this.activeTab = this.availableTabs[0]
    }

    if (this.chips === null) {
      this.chipsModel = []
    }
    this.copyValuesToTextarea()
  }
}
